import { ReactNode } from 'react';
import { ViagemParaTipoEscola } from '../../Views/Paginas/MinhasViagens/Escola/Viagens';
import { ViagemParaTipoResponsavel } from '../../Views/Paginas/MinhasViagens/Responsavel/Viagens';

export const Viagem = (props: {children: ReactNode}) => {
    return (
        <div style={{ margin: "1em", height: "100%" }}>
            {props.children}
        </div>
    );
};

Viagem.ParaTipoEscola = ViagemParaTipoEscola;
Viagem.ParaTipoResponsavel = ViagemParaTipoResponsavel;
